import React from "react";
import styled from "styled-components";
import { Card, InputField, PageTitle } from "../../../../v2/design-system";
import { theme } from "../../../../v2/design-system/theme";
import { HubFieldCell, HubFieldGrid, HubPageShell } from "../societyHubShell";

const Inner = styled.div`
  padding: ${theme.spacing.xl};
`;

const BasicFieldGrid = styled(HubFieldGrid)`
  gap: ${theme.spacing.xl};
`;

const BasicDetailsForm = ({ society }) => {
  const formFields = [
    { key: "orgName", label: "Organization Name", width: 6 },
    { key: "name", label: "Owner Name", width: 6 },
    { key: "mobileNo", label: "Mobile No", width: 6 },
    { key: "email", label: "Email", width: 6 },
    { key: "status", label: "Status", width: 6 },
    { key: "referralId", label: "Referral ID", width: 6 },
    { key: "programManagerName", label: "Program Manager Name", width: 6 },
    { key: "programManagerCode", label: "Program Manager Code", width: 6 },
  ];

  return (
    <HubPageShell>
      <Card style={{ overflow: "hidden" }}>
        <Inner>
          <PageTitle style={{ marginBottom: theme.spacing.xxl }}>Organization Basic Details</PageTitle>
          <BasicFieldGrid>
            {formFields.map((field) => {
              let value = society?.[field.key] || "";
              if (field.key === "status" && value) {
                value = value.toUpperCase();
              }
              return (
                <HubFieldCell key={field.key} $span={field.width}>
                  <InputField label={field.label} value={value} readOnly disabled />
                </HubFieldCell>
              );
            })}
          </BasicFieldGrid>
        </Inner>
      </Card>
    </HubPageShell>
  );
};

export default BasicDetailsForm;
